import React from 'react'

import { ProductIds } from 'core/application/commons/config'

import { ProductConfig } from '../providers/ProductProvider'

const useOverrideProduct = (overrideProductId: any = ProductIds.GroupHraId) => {
  if (overrideProductId === null) {
    throw new Error('{productId} cannot be null or unidentified!')
  }
  let overrideId = isNaN(overrideProductId) ? parseInt(overrideProductId) : overrideProductId
  return ProductConfig.get(parseInt(overrideId))
}

export default useOverrideProduct
